// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const altaria: PokeData = {
  "id": 334,
  "name": "altaria",
  "height": 11,
  "weight": 206,
  "base_experience": 172,
  "types": [
    PokeType.DRAGON,
    PokeType.FLYING
  ],
  "api_moves": [
    "fury-attack",
    "take-down",
    "growl",
    "sing",
    "mist",
    "peck",
    "sky-attack",
    "perish-song",
    "safeguard",
    "dragon-breath",
    "refresh",
    "astonish",
    "dragon-dance",
    "natural-gift",
    "pluck",
    "dragon-pulse",
    "round",
    "cotton-guard",
    "hurricane",
    "disarming-voice",
    "moonblast"
  ],
  "moves": [
    "growl",
    "peck",
    "sky-attack",
    "dragon-breath",
    "refresh",
    "dragon-dance",
    "dragon-pulse",
    "hurricane",
    "moonblast",
    "roost",
    "air-slash",
    "acrobatics",
    "dragon-fang"
  ],
  "evolution_chain": {
    "id": 168,
    "item": null,
    "species": [
      {
        "name": "swablu",
        "order": 361,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "altaria",
        "order": 362,
        "types": [
          PokeType.DRAGON,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 333,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 146,
    "speed": 135,
    "ability_power": 119
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
